import { confirmDeleteAccount, deleteAccount } from "apis/authApi";
import { doCall } from "common/genericSaga";
import { getCurrentVendor, mapToMerchandiseVendors } from "helpers/vendorHelper";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { oidc } from "services/oidcService";
import {
  CONFIRM_DELETE_ACCOUNT_REQUESTED,
  CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_REQUESTED,
  DELETE_ACCOUNT_REQUEST_FAILED,
  receiveConfirmDeleteAccount,
  receiveDeleteAccount
} from "./deleteAccountActions";

export function* doDeleteAccount(action, requestInfo) {
  const jwt = yield call(oidc.getCurrentUserJwt);
  const merchandiseVendor = mapToMerchandiseVendors(getCurrentVendor());
  yield call(deleteAccount, requestInfo, jwt.idp_type, jwt.idp_sub, merchandiseVendor);
  yield put(receiveDeleteAccount());
}

export function* doConfirmDeleteAccount(action, requestInfo) {
  const jwt = yield call(oidc.getCurrentUserJwt);
  yield call(confirmDeleteAccount, requestInfo, jwt.idp_type, jwt.idp_sub, action.confirmationToken);
  yield put(receiveConfirmDeleteAccount());
}

export function* watchDeleteAccount() {
  yield all([
    takeEvery(DELETE_ACCOUNT_REQUESTED, doCall(doDeleteAccount, DELETE_ACCOUNT_REQUEST_FAILED)),
    takeEvery(CONFIRM_DELETE_ACCOUNT_REQUESTED, doCall(doConfirmDeleteAccount, CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED))
  ]);
}
